import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Drivers from './delivery/Drivers';

const Delivery = () => {
  return (
    <Routes>
      <Route path="drivers" element={<Drivers />} />
      <Route path="" element={<Navigate to="drivers" replace />} />
    </Routes>
  );
};

export default Delivery;
